import { Crm } from 'domain/crm';
import { useCrmStatus } from 'hooks/useCrmStatus';
import { BulkCrmExportContainer } from 'pages/contacts/BulkActionBar/BulkCrmExportContainer';
import { useCrmActionsTracking } from 'pages/contacts/ContactItem/CrmExportActionsContainer/useCrmActionsTracking';
import { InactiveCrmExportButton } from 'pages/contacts/ContactItem/InactiveCrmExportButton';
import { NotConnectedCrmButton } from 'pages/contacts/ContactItem/NotConnectedCrmButton';

interface CrmExportButtonProps {
  isDisabled?: boolean;
  setShouldAnimatePrivateDataMount: (shouldAnimate: boolean) => void;
}

export const BulkCrmExportActionsContainer = ({ isDisabled }: CrmExportButtonProps) => {
  const { isHbIntegrated, isSfIntegrated, isHbExportEnabled, isSfExportEnabled, isLoading } = useCrmStatus();

  const { handleEnableExportTrack } = useCrmActionsTracking();

  if (isLoading) {
    return null;
  }

  if (!isHbIntegrated && !isSfIntegrated) {
    return (
      <NotConnectedCrmButton handleEnableExportTrack={handleEnableExportTrack} variant="bulk" isDisabled={isDisabled} />
    );
  }

  if (isHbIntegrated && !isSfIntegrated) {
    if (!isHbExportEnabled) {
      return (
        <InactiveCrmExportButton
          handleEnableExportTrack={handleEnableExportTrack}
          crm={Crm.hubspot}
          variant="bulk"
          isDisabled={isDisabled}
        />
      );
    }
    return <BulkCrmExportContainer isDisabled={isDisabled} crm={Crm.hubspot} />;
  }

  if (isSfIntegrated && !isHbIntegrated) {
    if (!isSfExportEnabled) {
      return (
        <InactiveCrmExportButton
          handleEnableExportTrack={handleEnableExportTrack}
          crm={Crm.salesforce}
          variant="bulk"
          isDisabled={isDisabled}
        />
      );
    }
    return <BulkCrmExportContainer isDisabled={isDisabled} crm={Crm.salesforce} />;
  }

  if (isHbIntegrated && isSfIntegrated) {
    if (!isSfExportEnabled && !isHbExportEnabled) {
      return (
        <InactiveCrmExportButton
          handleEnableExportTrack={handleEnableExportTrack}
          variant="bulk"
          isDisabled={isDisabled}
        />
      );
    }

    if (isSfExportEnabled && !isHbExportEnabled) {
      return <BulkCrmExportContainer isDisabled={isDisabled} crm={Crm.salesforce} />;
    }

    if (!isSfExportEnabled && isHbExportEnabled) {
      return <BulkCrmExportContainer isDisabled={isDisabled} crm={Crm.hubspot} />;
    }

    if (isHbIntegrated && isSfIntegrated && isSfExportEnabled && isHbExportEnabled) {
      return <BulkCrmExportContainer isDisabled={isDisabled} crm={Crm.salesforce} />;
    }
  }

  return null;
};
